// Core Web Vitals collection. Wires the field metrics the backend ingests (LCP — load,
// INP — interactivity, CLS — layout stability, plus FCP — first paint and TTFB — the
// document's first byte) into a single reporter that maps each `web-vitals` Metric to
// the generated `RumVital` wire shape. FCP and TTFB are not Core Web Vitals; they are
// here because a loading view that paints before the app script moves FCP and not LCP,
// and TTFB separates the edge's share of the wait from the page's (Monday 3327912434).
// Each metric reports at most once per page by default (web-vitals batches CLS/INP and
// emits the final value on hide), so the queue stays tiny.

import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from "web-vitals";

import type { RumVital } from "./types";

/** Register `onVital` to receive each Core Web Vital as it becomes final. */
export function registerVitals(onVital: (vital: RumVital) => void): void {
  const report = (metric: Metric): void => {
    onVital({
      name: metric.name,
      value: metric.value,
      rating: metric.rating,
      id: metric.id,
    });
  };
  onLCP(report);
  onINP(report);
  onCLS(report);
  onFCP(report);
  onTTFB(report);
}
